import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DriverHomeSection.css";
import driverImg from "../../assets/images/driverhome.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function DriverHomeSection() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      <Row className="d-flex justify-content-center align-items-center py-5">
        <Row className="d-flex justify-content-center align-items-center text-center">
          <Col xs="auto" data-aos="fade-right">
            <Button
              className="btn-orange driverHome-btn fw-bold shadow-lg"
              onClick={() => navigate("/transport")}
            >
              {t("driverHomeSection.offer")}
            </Button>
          </Col>
        </Row>
      </Row>

      <section className="driver-section py-5 mt-5">
        <Container>
          <Row className="align-items-center driverHomeSection-row">
            {/* Text */}
            <Col xs={12} md={8} className="text-white mb-4 mb-md-0">
              <h2 className="fw-bold mb-4 driverHomeSection-title">
                {t("driverHomeSection.title")}
              </h2>
              <p className="fw-bold text-orange mb-4 driverHomeSection-subtitle">
                {t("driverHomeSection.subtitle")}{" "}
                <span className="text-dark">
                  {t("driverHomeSection.subtitleHighlight")}
                </span>
              </p>
              
              <h5 className="fw-bold mb-3 driverHomeSection-prereq-title">
                {t("driverHomeSection.prerequisitesTitle")}
              </h5>
              
              <ul className="list-unstyled mb-4">
                <li className="mb-2 d-flex align-items-start">
                  <span className="checkmark me-2">✓</span>
                  <span className="driverHomeSection-list-item">{t("driverHomeSection.requirement1")}</span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="checkmark me-2">✓</span>
                  <span className="driverHomeSection-list-item">{t("driverHomeSection.requirement2")}</span>
                </li>
                <li className="mb-3 ms-4">
                  <span className="fst-italic small driverHomeSection-note">
                    {t("driverHomeSection.requirementNote")}
                  </span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="checkmark me-2">✓</span>
                  <span className="driverHomeSection-list-item fw-bold">{t("driverHomeSection.requirement3")}</span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="checkmark me-2">✓</span>
                  <span className="driverHomeSection-list-item">{t("driverHomeSection.requirement4")}</span>
                </li>
              </ul>
              
              <Button
                className="fw-bold shadow-sm btn-orange btn-xl"
                onClick={() => navigate("/register/driver")}
              >
                {t("driverHomeSection.buttonText")}
              </Button>
            </Col>

            {/* Driver Image */}
            <Col xs={12} md={4}>
              <div className="driver-card text-center overflow-hidden position-relative">
               
                <img
                  src={driverImg}
                  alt={t("driverHomeSection.imageAlt")}
                  className="img-fluid driver-img"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
